import React from 'react';
import { Box, Container, Typography, styled } from '@mui/material';

const Section = styled(Box)(({ theme }) => ({
    position: 'relative',
    paddingTop: theme.spacing(6.5),
    paddingBottom: theme.spacing(6.5),
    background: 'linear-gradient(180deg, #FFFFFF 0%, #F7F9FF 50%, #FFFFFF 100%)',
    overflow: 'hidden',
    '--ink': '#070B16',
    '--muted': '#475569',
    '--line': 'rgba(15, 23, 42, 0.10)',
    '--accent': '#0066FF',
    '--accent2': '#6366F1',
    '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        background:
            'radial-gradient(ellipse 52% 38% at 18% 30%, rgba(0, 102, 255, 0.08) 0%, transparent 70%), radial-gradient(ellipse 48% 36% at 86% 65%, rgba(99, 102, 241, 0.08) 0%, transparent 70%)',
        pointerEvents: 'none',
    },
    [theme.breakpoints.down('md')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
    },
}));

const Card = styled(Box)({
    position: 'relative',
    // borderRadius: '26px',
    // padding: '34px 34px',
    // background:
    //     'linear-gradient(180deg, rgba(255, 255, 255, 0.82) 0%, rgba(248, 250, 255, 0.62) 100%)',
    // border: '1px solid rgba(15, 23, 42, 0.10)',
    // boxShadow: '0 34px 90px rgba(2, 6, 23, 0.08), 0 10px 28px rgba(0, 102, 255, 0.06)',
    // backdropFilter: 'blur(14px)',
    // overflow: 'hidden',
    // '&::before': {
    //     content: '""',
    //     position: 'absolute',
    //     inset: 0,
    //     background:
    //         'linear-gradient(135deg, rgba(0, 102, 255, 0.12) 0%, rgba(99, 102, 241, 0.10) 45%, transparent 100%)',
    //     opacity: 0.65,
    //     pointerEvents: 'none',
    // },
    // '&::after': {
    //     content: '""',
    //     position: 'absolute',
    //     left: 0,
    //     top: 0,
    //     width: '4px',
    //     height: '100%',
    //     background: 'linear-gradient(180deg, var(--accent) 0%, var(--accent2) 100%)',
    //     opacity: 0.95,
    // },
    // '@media (max-width: 600px)': {
    //     padding: '26px 20px',
    //     borderRadius: '18px',
    // },
});

const Inner = styled(Box)({
    position: 'relative',
    zIndex: 1,
    maxWidth: '980px',
    margin: '0 auto',
    textAlign: 'center',
});

const Kicker = styled(Typography)(({ theme }) => ({
    display: 'inline-block',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: '#0066FF',
    backgroundColor: 'rgba(0, 102, 255, 0.1)',
    padding: theme.spacing(0.75, 1.75),
    borderRadius: 999,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        fontSize: '0.75rem',
        padding: theme.spacing(0.75, 2.25),
    },
}));

const Title = styled(Typography)(({ theme }) => ({
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.22,
    letterSpacing: '-0.03em',
    color: '#0F172A',
    margin: 0,
    [theme.breakpoints.up('sm')]: {
        fontSize: '2.125rem',
    },
    [theme.breakpoints.up('md')]: {
        fontSize: '2.5rem',
    },
    [theme.breakpoints.up('lg')]: {
        fontSize: '2.75rem',
    },
}));

const Lead = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(1.5),
    fontSize: '1rem',
    lineHeight: 1.75,
    fontWeight: 400,
    color: 'rgba(15, 23, 42, 0.82)',
    [theme.breakpoints.up('sm')]: {
        fontSize: '1.0625rem',
    },
    [theme.breakpoints.up('md')]: {
        fontSize: '1.125rem',
    },
}));

const AuditReadySection = () => {
    return (
        <Section component="section" aria-labelledby="company-audit-title">
            <Container maxWidth="lg">
                <Card>
                    <Inner>
                        <Kicker component="p">Compliance</Kicker>
                        <Title variant="h2" id="company-audit-title">
                            When the audit question comes up, you're not starting from scratch.
                        </Title>
                        <Lead component="p">
                            Consent documented. Records encrypted. Access role-based. DPDP penalties can
                            reach ₹250 crore. Centres on meDZhub aren't unprepared.
                        </Lead>
                    </Inner>
                </Card>
            </Container>
        </Section>
    );
};

export default AuditReadySection;

